import { IconMinus, IconPlus } from '@tabler/icons-react';
import { rupiah } from 'lib/currency';
import useImageFetcher from 'lib/hooks/useImageFetcher';

const CartSimple = ({ item, quantity, setQuantity }) => {
  const { category, package_name, price, type, images } = item ?? {};
  const { imageUrls, loading } = useImageFetcher(images, true);

  const CATEGORY_LIST = [
    { id: 0, name: 'CLASS PASS', value: 'CLASS' },
    { id: 1, name: 'EXHIBITION + PLAY', value: 'EXHIBITION + PLAY' },
    { id: 2, name: 'EXHIBITION ONLY', value: 'EXHIBITION ONLY' },
  ];
  const findCategory = (id) => CATEGORY_LIST.find((c) => c.id === id)?.name ?? 'Unknown';

  const handleAdd = () => setQuantity((q) => q + 1);
  const handleRemove = () => setQuantity((q) => Math.max(1, q - 1));

  return (
    <div className="flex flex-row gap-2 py-4 justify-between items-center">
      <div className="flex flex-row gap-3 items-center">
        <div className="min-h-[70px] min-w-[70px] relative">
          {loading ? (
            <div className="flex justify-center items-center h-full w-full text-xs">Loading...</div>
          ) : (
            <img
              alt={package_name}
              src={imageUrls?.[0]}
              className="absolute inset-0 h-full w-full object-cover rounded-lg"
            />
          )}
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="leading-[normal] font-light text-sm">{findCategory(category)}</span>
          <span className="leading-[normal] text-base font-bold">
            {/* Valid for {item?.validity_period_month ? item?.validity_period_month : 'Everyday'} */}
            {item?.package_name || '-'}
          </span>
          <span className="leading-[normal] font-light text-sm uppercase ">
            {/* Usage for {item?.credit_number || '0'} times */}
            {item?.category === 0 ? `${item?.type || ''} CLASS` : item?.type}
          </span>
        </div>
      </div>

      <div className="flex flex-col items-center gap-2">
        <span className="leading-[normal] text-sm font-semibold">
          {price ? rupiah(price) : 'Rp -'}
        </span>
        <div className="mt-1 border border-kin-text rounded-2xl gap-2 flex flex-row justify-between items-center">
          <button onClick={handleRemove} type="button" className="p-2" aria-label="Kurangi">
            <IconMinus
              className={`w-4 h-4 ${quantity === 1 ? 'text-gray-400' : 'text-kin-text'}`}
            />
          </button>
          <div className="flex justify-center items-center w-4 text-center min-w-[16px]">
            <span className="leading-[normal] text-sm">{quantity}</span>
          </div>
          <button onClick={handleAdd} type="button" className="p-2" aria-label="Tambah">
            <IconPlus className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartSimple;
